export const LOW_REMAINING_MINUTES = 60

export type RemainingLevel = 'unknown' | 'exceeded' | 'low' | 'ok'

export interface ForecastUser {
  id: string
  fullName: string
}

export interface ForecastFilter {
  users: string[]
  leaderGroupUserIds: string[] | null
}

export function formatMinutes(minutes: number | null | undefined): string {
  if (minutes === null || minutes === undefined) return '–'

  const total = Math.round(Math.abs(minutes))
  const hours = Math.floor(total / 60)
  const rest = (total % 60).toString().padStart(2, '0')
  const sign = minutes < 0 && total > 0 ? '-' : ''

  return `${sign}${hours}:${rest}`
}

export function remainingLevel(
  minutes: number | null | undefined
): RemainingLevel {
  if (minutes === null || minutes === undefined) return 'unknown'
  if (minutes <= 0) return 'exceeded'
  if (minutes < LOW_REMAINING_MINUTES) return 'low'
  return 'ok'
}

export function filterForecasts<T extends { user: ForecastUser | null }>(
  forecasts: T[],
  filter: ForecastFilter
): (T & { user: ForecastUser })[] {
  const users = new Set(filter.users)
  const leaderGroupUsers = filter.leaderGroupUserIds
    ? new Set(filter.leaderGroupUserIds)
    : null

  return forecasts.filter(
    (forecast): forecast is T & { user: ForecastUser } => {
      const user = forecast.user
      if (!user) return false
      if (users.size > 0 && !users.has(user.id)) return false
      if (leaderGroupUsers && !leaderGroupUsers.has(user.id)) return false
      return true
    }
  )
}
